import { Decision } from '@/shared/api/protocol-ts/model/dto_report_common_pb';

import {
  conditionIsActive,
  conditionIsActiveForFDA,
  isUserPositiveCertainty,
} from '@/entities/condition';

import type { GetParentConditionIDsToEnableParams } from '../config';

export const getParentConditionIDsToEnable = ({
  isFDAVersion2,
  isUnaided,
  userDecision,
  parentConditions,
}: GetParentConditionIDsToEnableParams): string[] => {
  if (!isFDAVersion2 || userDecision !== Decision.PositiveDecision) {
    return [];
  }

  return parentConditions
    .filter(
      (parentCondition) =>
        !conditionIsActive(parentCondition) ||
        !(isUnaided
          ? isUserPositiveCertainty(parentCondition.Certainty)
          : conditionIsActiveForFDA(parentCondition)),
    )
    .map((parentCondition) => parentCondition.ID);
};
